import { render, staticRenderFns } from "./challange-counter.vue?vue&type=template&id=a31c899a&"
import script from "./challange-counter.vue?vue&type=script&lang=js&"
export * from "./challange-counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports